import GlobalStore from '@vuejs/stores/GlobalStore'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useFeatureFlagStore = defineStore('featureFlag', () => {
	// State
	const flags = ref<FeatureFlags>({
		activated_insights_billing_ui: false,
		advanced_automation: false,
		advanced_reporting: false,
		completion_importing: false,
		curriculum_discoverability: false,
		customized_curriculum: false,
		disable_delinquency_banners: false,
		enroll_annual_next_year: false,
		plg_eccomerce_enabled: false,
		specialized_certification_feature: false,
	})

	// Getters
	const getFeatureStatus = computed(() => {
		return (featureName: string, defaultValue: boolean = false) => {
			if (featureName in flags.value) {
				return flags.value[featureName as keyof FeatureFlags]
			}

			return defaultValue
		}
	})

	const isFeatureEnabled = computed(() => {
		return (featureName: keyof FeatureFlags): boolean => {
			if (featureName in flags.value) {
				return flags.value[featureName]
			}

			return false
		}
	})

	// Actions
	function loadFeatureFlags() {
		const element = document.getElementById('current-user-json')

		if (element) {
			try {
				const featureFlagConfig = JSON.parse(element.textContent || '{}')
				const featureFlags = featureFlagConfig.featureFlags

				if (featureFlags) {
					flags.value = featureFlags

					GlobalStore.isSharedCompletionsEnabled = isFeatureEnabled.value('completion_importing')
				}
			} catch (error) {
				GlobalStore.onHandleErrorMessages({ error })
			}
		}
	}

	return {
		// State
		flags,

		// Getters
		getFeatureStatus,
		isFeatureEnabled,

		// Actions
		loadFeatureFlags,
	}
})

export interface FeatureFlags {
	activated_insights_billing_ui: boolean
	advanced_automation: boolean
	advanced_reporting: boolean
	completion_importing: boolean
	curriculum_discoverability: boolean
	customized_curriculum: boolean
	disable_delinquency_banners: boolean
	enroll_annual_next_year: boolean
	plg_eccomerce_enabled: boolean
	specialized_certification_feature: boolean
}

export type FeatureFlagKey = keyof FeatureFlags
